// Temperature Icons
import ambientIcon from "../../assets/icons/temperature/ambient_icon.svg";
import cargoIcon from "../../assets/icons/temperature/cargo_icon.svg";
import emulsionIcon from "../../assets/icons/temperature/emulsion_icon.svg";
import engineIcon from "../../assets/icons/temperature/engine_icon.svg";
import fridgeIcon from "../../assets/icons/temperature/fridge_icon.svg";
import TemperatureDefaultIcon from "../../assets/icons/temperature/Temperature.svg";

// FDM Temperature Icons
import ambientIconFDM from "../../assets/icons/temperature/ambient_icon.svg?raw";
import cargoIconFDM from "../../assets/icons/temperature/cargo_icon.svg?raw";
import emulsionIconFDM from "../../assets/icons/temperature/emulsion_icon.svg?raw";
import engineIconFDM from "../../assets/icons/temperature/engine_icon.svg?raw";
import fridgeIconFDM from "../../assets/icons/temperature/fridge_icon.svg?raw";
import TemperatureDefaultIconFDM from "../../assets/icons/temperature/Temperature.svg?raw";

// Switch State Icons
import switchStateDefaultIcon from "../../assets/icons/switchState/switch-on-off.svg";
import ArmIcon from "../../assets/icons/switchState/arm.svg";
import auxiliaryEngine from "../../assets/icons/switchState/auxiliary_engine.svg";
import binLifting from "../../assets/icons/switchState/bin_lifting.svg";
import bitumenFilling from "../../assets/icons/switchState/bitumen_filling.svg";
import BrushRoller from "../../assets/icons/switchState/brush_roller.svg";
import brushesIcon from "../../assets/icons/switchState/brushes.svg";
import CargoDoor from "../../assets/icons/switchState/cargo_door.svg";
import compactionCycle from "../../assets/icons/switchState/compaction_cycle.svg";
import concreteIdleCycle from "../../assets/icons/switchState/concrete_idle_cycle.svg";
import concreteLoadingCycle from "../../assets/icons/switchState/concrete_loading_cycle.svg";
import concreteMixing from "../../assets/icons/switchState/concrete_mixing.svg";
import concretePumping from "../../assets/icons/switchState/concrete_pumping.svg";
import concreteSpreading from "../../assets/icons/switchState/concrete_spreading.svg";
import doorLocking from "../../assets/icons/switchState/door_locking.svg";
import doorOpening from "../../assets/icons/switchState/door_opening.svg";
import emulsionHeating from "../../assets/icons/switchState/emulsion_heating.svg";
import EquipmentIcon from "../../assets/icons/switchState/equipment.svg";
import EquipmentPanel from "../../assets/icons/switchState/equipment_panel.svg";
import extendedCrane from "../../assets/icons/switchState/extended_crane.svg";
import FridgeEngine from "../../assets/icons/switchState/fridge_engine.svg";
import GrapeConveyorBelt from "../../assets/icons/switchState/grape_conveyor_belt.svg";
import hooklifArm from "../../assets/icons/switchState/hooklif_arm.svg";
import hooksOperation from "../../assets/icons/switchState/hooks_operation.svg";
import HopperIcon from "../../assets/icons/switchState/hopper.svg";
import hydraulicEquipment from "../../assets/icons/switchState/hydraulic_equipment.svg";
import loadingFloor from "../../assets/icons/switchState/loading_floor.svg";
import millingDrum from "../../assets/icons/switchState/milling_drum.svg";
import movingFloor from "../../assets/icons/switchState/moving_floor.svg";
import PanicButton from "../../assets/icons/switchState/panic_button.svg";
import powerTakeOff from "../../assets/icons/switchState/power_take_off.svg";
import pressurePump from "../../assets/icons/switchState/pressure_pump.svg";
import rollerVibration from "../../assets/icons/switchState/roller_vibration.svg";
import rotatingArm from "../../assets/icons/switchState/rotating_arm.svg";
import ScreenConveyorBelt from "../../assets/icons/switchState/screen_conveyor_belt.svg";
import sideBrushes from "../../assets/icons/switchState/side_brushes.svg";
import suctionIcons from "../../assets/icons/switchState/suction.svg";
import tarpSystem from "../../assets/icons/switchState/tarp_system.svg";
import tippingTrailer from "../../assets/icons/switchState/tipping_trailer.svg";
import TractorUncoupling from "../../assets/icons/switchState/tractor_uncoupling.svg";
import turbineIcon from "../../assets/icons/switchState/turbine.svg";
import unloadingFloor from "../../assets/icons/switchState/unloading_floor.svg";
import vacuumPump from "../../assets/icons/switchState/vacuum_pump.svg";
import waterPump from "../../assets/icons/switchState/water_pump.svg";
import waterReservoir from "../../assets/icons/switchState/water_reservoir.svg";
import WeighingButton from "../../assets/icons/switchState/weighing_button.svg";
import WorkEnable from "../../assets/icons/switchState/work_enable.svg";

// Relay Status Icons
import RelayStatusDefaultIcon from "../../assets/icons/switchState/switch-on-off.svg";
import ignitionLockIcon from "../../assets/icons/relayStatus/ignition_lock.svg";
import equipmentLockIcon from "../../assets/icons/relayStatus/equipment_lock.svg";
import controlLockIcon from "../../assets/icons/relayStatus/controlLock.svg";
import umpingLockIcon from "../../assets/icons/relayStatus/umping_lock.svg";
import powerReductionIcon from "../../assets/icons/relayStatus/power_reduction.svg";
import buzzerActivationIcon from "../../assets/icons/relayStatus/buzzerActivation.svg";
import ledActivationIcon from "../../assets/icons/relayStatus/LED_activation.svg";

export const PAGINATION_CONSTANT = {
  pageIndex: 0,
  pageSize: 10,
  sort: "DESC",
  sortBy: "ID",
};
export const USER_ROLE = {
  CRMAdmin: "CRMAdmin",
  CRMUser: "CRMUser",
  CustomerAdmin: "CustomerAdmin",
  CustomerUser: "CustomerUser",
  SuperUser: "SuperUser",
  RootrUser: "RootUser",
};
export const TYRE_STATUS_ICON_COLOR = Object.freeze({
  // 0: "#1E4620", // Darker Blue
  // 1: "#CC8A00", // Darker Yellow (warning)
  // 2: "#CC0000", // Darker Red (warning)
  // 3: "#CC8A00", // Darker Yellow (error)
  // 4: "#CC0000", // Darker Red (warning)
  // 7: "#CC8A00", // Darker Yellow (warning)
  // 8: "#CC0000", // Darker Red (warning)

  0: "#35d735", // Darker Blue
  1: "#C08200", // Darker Yellow (warning)
  2: "#EB3B5A", // Darker Red (warning)
  3: "#C08200", // Darker Yellow (error)
  4: "#EB3B5A", // Darker Red (warning)
  7: "#C08200", // Darker Yellow (warning)
  8: "#EB3B5A", // Darker Red (warning)
});
export const getAlertKeyFromText = (text) => {
  switch (text) {
    case "GENERIC ERROR":
      return "error";
    case "WARNING PRESSURE":
      return "warning_pressure";
    case "ALERT PRESSURE":
      return "alert_pressure";
    case "WARNING TEMPERATURE":
      return "warning_temp";
    case "ALERT TEMPERATURE":
      return "alert_temp";
    case "MISSING SENSOR":
      return "missing";
    case "LOW BATTERY SENSOR":
      return "low_battery";
    case "WARNING TIRE CONTROL":
      return "warning_tire_control";
    case "TACHO INSUFFICIENT BREAK":
      return "tacho_insufficient_break";
    case "TACHO WORK TIME EXCEEDED":
      return "tacho_work_time_exceeded";
    case "TACHO DRIVING TIME EXCEEDED":
      return "tacho_driving_time_exceeded";

    default:
      return "unknown_alert";
  }
};
export const alertTypes = {
  0: "GENERIC ERROR",
  1: "WARNING PRESSURE",
  2: "ALERT PRESSURE",
  3: "WARNING TEMPERATURE",
  4: "ALERT TEMPERATURE",
  5: "MISSING SENSOR",
  6: "LOW BATTERY SENSOR",
  7: "WARNING TIRE CONTROL",
  8: "ALERT TIRE CONTROL",
  9: "TACHO INSUFFICIENT BREAK",
  10: "TACHO WORK TIME EXCEEDED",
  11: "TACHO DRIVING TIME EXCEEDED",
  undefined: "GENERIC ERROR",
};
export const TYRE_STATUS_COLOR = Object.freeze({
  0: "#EDF7ED",
  1: "#FFF4E5", // LowBattery (warning)
  2: "#FDEDED", // LowPressure (warning)
  3: "#FFF4E5", // HighPressure (error)
  4: "#FDEDED", // HighPressure (warning)
});
export const formatDateCurrentLan = (dateString, language, targetTimeZone) => {
  if (!dateString) return "";

  const str = String(dateString);

  const date = new Date(str?.endsWith("Z") ? str : `${str}Z`);
  if (isNaN(date.getTime())) return "";

  const options = {
    year: language === "it" ? "2-digit" : "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone:
      targetTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  try {
    let formatted = new Intl.DateTimeFormat(
      language || "en-US",
      options,
    ).format(date);
    return formatted.replace(", ", " ");
  } catch (e) {
    console.error(`Date formatting failed for ${targetTimeZone}:`, e);
    return "";
  }
};
export const getAlertDetails = (alertCode) => {
  const alertText =
    alertCode && alertTypes[alertCode]
      ? alertTypes[alertCode]
      : "unknown_alert";

  const text = getAlertKeyFromText(alertText);

  const alertCodeFive = alertCode === 5;
  const alertCodeGreaterAndLess = alertCode >= 1 && alertCode <= 5;

  const color = alertCodeFive
    ? "#99A1BF"
    : alertCodeGreaterAndLess
      ? TYRE_STATUS_ICON_COLOR[alertCode]
      : "#99A1BF";

  const alertBgColor = alertCodeFive
    ? "#fff"
    : alertCodeGreaterAndLess
      ? TYRE_STATUS_COLOR[alertCode]
      : "#00000008";

  const bgColorGreaterThenFive =
    alertCode < 1 || alertCode > 5
      ? "#FFF"
      : alertCodeGreaterAndLess
        ? TYRE_STATUS_COLOR[alertCode]
        : "#007acc14";

  return { text, bgColorGreaterThenFive, color, alertBgColor };
};

export const temperatureIconMapFDM = {
  ambient: ambientIconFDM,
  engine: engineIconFDM,
  fridge: fridgeIconFDM,
  cargo: cargoIconFDM,
  emulsion: emulsionIconFDM,
  default: TemperatureDefaultIconFDM,
};
export const temperatureIconMap = {
  ambient: ambientIcon,
  engine: engineIcon,
  fridge: fridgeIcon,
  cargo: cargoIcon,
  emulsion: emulsionIcon,
  default: TemperatureDefaultIcon,
};
export const switchStateIconMap = {
  default: switchStateDefaultIcon,
  bitumen_filling: bitumenFilling,
  concrete_mixing: concreteMixing,
  power_take_off: powerTakeOff,
  compaction_cycle: compactionCycle,
  bin_lifting: binLifting,
  hooklift_arm: hooklifArm,
  water_pump: waterPump,
  vacuum_pump: vacuumPump,
  pressure_pump: pressurePump,
  concrete_pumping: concretePumping,
  concrete_loading_cycle: concreteLoadingCycle,
  concrete_idle_cycle: concreteIdleCycle,
  hooks_operation: hooksOperation,
  hydraulic_equipment: hydraulicEquipment,
  moving_floor: movingFloor,
  door_locking: doorLocking,
  door_opening: doorOpening,
  tarp_system: tarpSystem,
  loading_floor: loadingFloor,
  unloading_floor: unloadingFloor,
  extended_crane: extendedCrane,
  tipping_trailer: tippingTrailer,
  hopper: HopperIcon,
  brushes: brushesIcon,
  arm: ArmIcon,
  rotating_arm: rotatingArm,
  roller_vibration: rollerVibration,
  concrete_spreading: concreteSpreading,
  auxiliary_engine: auxiliaryEngine,
  side_brushes: sideBrushes,
  suction: suctionIcons,
  milling_drum: millingDrum,
  emulsion_heating: emulsionHeating,
  turbine: turbineIcon,
  water_reservoir: waterReservoir,
  brush_roller: BrushRoller,
  equipment_panel: EquipmentPanel,
  equipment: EquipmentIcon,
  weighing_button: WeighingButton,
  panic_button: PanicButton,
  cargo_door: CargoDoor,
  fridge_engine: FridgeEngine,
  grape_conveyor_belt: GrapeConveyorBelt,
  work_enable: WorkEnable,
  screen_conveyor_belt: ScreenConveyorBelt,
  tractor_uncoupling: TractorUncoupling,
};
export const relayStatusIconMap = {
  default: RelayStatusDefaultIcon,
  ignition_lock: ignitionLockIcon,
  equipment_lock: equipmentLockIcon,
  control_lock: controlLockIcon,
  pumping_lock: umpingLockIcon,
  power_reduction_machine_throttle_lock: powerReductionIcon,
  buzzer_activation: buzzerActivationIcon,
  led_activation: ledActivationIcon,
};

export const DATE_FORMATS_BY_LOCAL = {
  en: "YYYY-MM-DD",
  it: "DD/MM/YYYY",
  fr: "DD/MM/YYYY",
  de: "DD.MM.YYYY",
};

export const getDateFormatByLocal = (locale) => {
  if (!locale) return DATE_FORMATS_BY_LOCAL.en;

  // Extract language part (e.g., "it" from "it-IT")
  const language = locale.split("-")[0];

  return DATE_FORMATS_BY_LOCAL[language] || DATE_FORMATS_BY_LOCAL.en;
};